export default "__VITE_ASSET__BeLokj20__"